import {
    OPEN_INITIAL_SETUP_EVENT,
    OPEN_JOIN_EXISTING_PARISH_EVENT,
} from 'Screens/Dashboard/InitialSetup/constants';
import { UnauthorizedEmptyState } from '@carbon/ibm-products';
import {
    Button,
    Container,
} from '@mantine/core';
import { defineMessages, useIntl } from 'react-intl';
import styles from './NotConfiguredEmptyState.module.scss';
import useGetUser from 'hooks/useGetUser';
import { OPEN_ADD_PARISH_EVENT } from 'Screens/Dashboard/AllEntities/constants';

const NotConfiguredEmptyState = () => {
    const intl = useIntl();
    const user = useGetUser();
    const hasAnyEntity = Boolean(user?.entities.length);
    const requiresParish = Boolean(user?.hasInitialSetupCompleted && !hasAnyEntity);
    const canJoinExistingParish = Boolean(user && (!user.hasInitialSetupCompleted || requiresParish));

    const openRequiredConfiguration = () => {
        window.dispatchEvent(new Event(requiresParish ? OPEN_ADD_PARISH_EVENT : OPEN_INITIAL_SETUP_EVENT));
    };

    const openJoinExistingParish = () => {
        window.dispatchEvent(new Event(OPEN_JOIN_EXISTING_PARISH_EVENT));
    };

    return (
        <Container className={styles.container} fluid py="xl">
            <div className={styles.initialSetupEmptyState}>
                <UnauthorizedEmptyState
                    headingAs="h3"
                    illustrationDescription={intl.formatMessage(messages.initialSetupRequiredIllustration)}
                    subtitle={intl.formatMessage(requiresParish ? messages.parishRequiredSubtitle : messages.initialSetupRequiredSubtitle)}
                    title={intl.formatMessage(requiresParish ? messages.parishRequiredTitle : messages.initialSetupRequiredTitle)}
                />
                {canJoinExistingParish && (
                    <Button
                        variant="filled"
                        className={styles.joinExistingButton}
                        onClick={openJoinExistingParish}
                    >
                        {intl.formatMessage(messages.joinExistingParish)}
                    </Button>
                )}
                <Button
                    variant="outline"
                    className={styles.initialSetupButton}
                    onClick={openRequiredConfiguration}
                >
                    {intl.formatMessage(requiresParish ? messages.addParish : messages.finishInitialSetup)}
                </Button>
            </div>
        </Container>
    );
};

const messages = defineMessages({
    initialSetupRequiredTitle: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.initialSetupRequiredTitle',
        defaultMessage: 'Dokończ konfigurację parafii',
    },
    initialSetupRequiredSubtitle: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.initialSetupRequiredSubtitle',
        defaultMessage: 'Ta sekcja będzie dostępna po zakończeniu pierwszej konfiguracji. Wróć do niej teraz, żeby wybrać plan i uzupełnić potrzebne dane.',
    },
    initialSetupRequiredIllustration: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.initialSetupRequiredIllustration',
        defaultMessage: 'Brak dostępu do tej sekcji przed ukończeniem konfiguracji',
    },
    finishInitialSetup: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.finishInitialSetup',
        defaultMessage: 'Dokończ konfigurację',
    },
    parishRequiredTitle: {
        id: 'src.Components.Common.NotConfiguredEmptyState.parishRequiredTitle',
        defaultMessage: 'Dodaj parafię',
    },
    parishRequiredSubtitle: {
        id: 'src.Components.Common.NotConfiguredEmptyState.parishRequiredSubtitle',
        defaultMessage: 'Ta sekcja będzie dostępna po dodaniu parafii. Uzupełnij jej dane, aby odblokować panel.',
    },
    addParish: {
        id: 'src.Components.Common.NotConfiguredEmptyState.addParish',
        defaultMessage: 'Dodaj parafię',
    },
    joinExistingParish: {
        id: 'src.Components.Common.NotConfiguredEmptyState.joinExistingParish',
        defaultMessage: 'Dołącz do istniejącej parafii',
    },
});

export default NotConfiguredEmptyState;
